import MessagesInbox from './messages-inbox-wrapper';

export default MessagesInbox;
